import i18n from '@/i18n';
import { isEmbed, isWxwork } from '@/tools/utils';
import $store from '@/store';

// 菜单处理
export const _FULL_MENUS = [
  {
    index: 'video-base',
    title: `${i18n.t('ai.k_003001')}`,
    children: [
      {
        index: 'AiVideoParsing',
        feature: 'ai_video_parsing',
        title: `${i18n.t('ai.k_003002')}`
      },
      {
        index: 'AiVideoSubtitles',
        feature: 'ai_video_subtitles',
        title: `${i18n.t('ai.k_003003')}`
      }
    ]
  },
  {
    index: 'video-operate',
    title: `${i18n.t('ai.k_003004')}`,
    children: [
      {
        index: 'AiVideoMoments',
        feature: 'ai_video_moments',
        title: `${i18n.t('ai.k_003005')}`
      },
      {
        index: 'AiVideoClip',
        feature: 'ai_video_clip',
        title: `${i18n.t('ai.k_003006')}`
      },
      {
        index: 'AiVideoSummary',
        feature: 'ai_video_summary',
        title: `${i18n.t('ai.k_003007')}`
      }
    ]
  }
];
export const _FULL_NAVS = [
  {
    id: 'miSubtitles',
    feature: 'ai_video_subtitles',
    class: 'subtitles',
    title: `${i18n.t('ai.k_003003')}`,
    description: `${i18n.t('ai.k_003008')}`,
    image: new URL('@/assets/images/ai-icon-subtitles.png', import.meta.url).href,
    marked: false,
    navTo: `/video/subtitles/`
  },
  {
    id: 'miMoments',
    feature: 'ai_video_moments',
    class: 'moments',
    title: `${i18n.t('ai.k_003005')}`,
    description: `${i18n.t('ai.k_003009')}`,
    image: new URL('@/assets/images/ai-icon-moments.png', import.meta.url).href,
    marked: false,
    navTo: `/video/moments/`
  },
  {
    id: 'miClip',
    feature: 'ai_video_clip',
    class: 'clip',
    title: `${i18n.t('ai.k_003006')}`,
    description: `${i18n.t('ai.k_003010')}`,
    image: new URL('@/assets/images/ai-icon-clip.png', import.meta.url).href,
    marked: false,
    navTo: `/video/clip/`
  },
  {
    id: 'miSummary',
    feature: 'ai_video_summary',
    class: 'summary',
    title: `${i18n.t('ai.k_003007')}`,
    description: `${i18n.t('ai.k_003011')}`,
    image: new URL('@/assets/images/ai-icon-summary.png', import.meta.url).href,
    marked: false,
    navTo: `/video/summary/`
  }
];
export const getCurrentMenus = function () {
  if (!isEmbed()) {
    // 标品返回完全菜单
    return _FULL_MENUS;
  }

  // 嵌入页菜单
  let menus = [];
  if ($store.state.embedCfg.feature) {
    for (const item of _FULL_MENUS) {
      const cld = item.children.filter(subItem => {
        return $store.state.embedCfg.feature[subItem.feature];
      });
      if (cld && cld.length) {
        menus.push({
          ...item,
          children: cld
        });
      }
    }
  }
  return menus;
};
export const getCurrentNav = function () {
  if (!isEmbed()) {
    // 标品返回完全
    return _FULL_NAVS;
  }
  let navs = [];
  if ($store.state.embedCfg.feature) {
    navs = _FULL_NAVS.filter(item => {
      return !!$store.state.embedCfg.feature[item.feature];
    });
  }
  const prefix = isWxwork() ? '/embed/wxwork' : '/embed';
  navs = navs.map(item => {
    return {
      ...item,
      navTo: `${prefix}${item.navTo}`
    };
  });
  return navs;
};
